import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import { LanguageContext, LanguageConsumer } from './lib/LanguageContext'
import Footer from './Footer'
import * as apiCalls from './lib/apiCalls';
import './Login.css'

const SERERROR = 500;
const loginFailed = 'loginFailed';
const loginError = 'loginError';
const emptyId = 'emptyId';
const emptyToken = 'emptyToken';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            institutionId: '',
            key: '',
            idFocus: false,
            keyFocus: false,
            error: false,
            redirect: false,
            errorMessages: [],
            timers: [],
            transition: true,
            next: '/'
        }
    }

    handleIdChange = (e) => {
        let value = e.target.value.toLowerCase();
        let errorMessages = this.state.errorMessages;
        let error = this.state.error;
        if(value.trim()) {
            errorMessages = errorMessages.filter(err => err !== emptyId && err !== loginFailed && err !== loginError)
            if(errorMessages.filter(err => err !== emptyId && err !== loginFailed && err !== loginError).length === 0) {
                error = false;
            }
        }
        this.setState(prevState => ({
            ...prevState,
            institutionId: value,
            error,
            errorMessages
        }))
    }

    updateComponent = () => {
        let next = '/';
        if(this.props.search.slice(1, this.props.search.indexOf('=')) === 'next') {
            next = this.props.search.slice(this.props.search.indexOf('=')+1)
        }
        this.setState(prevState => ({
            ...prevState,
            next
        }))
    }

    componentDidMount() {
        document.title = this.context.polyglot.t('loginPageTitle');
        let content = document.getElementById('content');
        content.scrollTop = 0;
        this.updateComponent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search) {
            this.updateComponent();
        }
    }

    componentWillMount() {
        if(this.props.isLoggedIn) {
            this.setState(prevState => ({
                ...prevState,
                next: '/',
                redirect: true
            }))
        }
        this.setState(prevState => ({
            ...prevState,
            timers: [...prevState.timers, [
                setTimeout(() => {
                    this.setState(prevState => ({
                        ...prevState,
                        transition: false
                    }))
                }, 100)
            ]]
        }))
    }

    handleKeyChange = (e) => {
        let value = e.target.value;
        let errorMessages = this.state.errorMessages;
        let error = this.state.error;
        if(value.trim()) {
            errorMessages = errorMessages.filter(err => err !== emptyToken && err !== loginFailed && err !== loginError)
            if(errorMessages.filter(err => err !== emptyToken && err !== loginFailed && err !== loginError).length === 0) {
                error = false;
            }
        }
        this.setState(prevState => ({
            ...prevState,
            key: value,
            error,
            errorMessages
        }))
    }

    onIdFocus = (e) => {
        this.setState(prevState => ({
            ...prevState,
            idFocus: true
        }))
    }

    onIdBlur = (e) => {
        this.setState(prevState => ({
            ...prevState,
            idFocus: false
        }))
    }

    onKeyFocus = (e) => {
        this.setState(prevState => ({
            ...prevState,
            keyFocus: true
        }))
    }

    onKeyBlur = (e) => {
        this.setState(prevState => ({
            ...prevState,
            keyFocus: false
        }))
    }

    redirect = () => {
        this.props.handleLogin(this.state.institutionId, this.state.key);
        this.setState(prevState => ({
            ...prevState,
            redirect: true
        }))
    }

    componentWillUnmount() {
        this.state.timers.map(timer => clearTimeout(timer));
    }

    login = async () => {
        const res = await apiCalls.loginAttempt(this.state.institutionId, this.state.key);
        if(res === SERERROR) {
            return this.setState(prevState => ({
                ...prevState,
                error: true,
                errorMessages: [
                    ...prevState.errorMessages.filter(err => err !== loginError),
                    loginError
                ]
            }))
        }
        if(res.validated === true) {
            this.setState(prevState => ({
                ...prevState,
                transition: true,
                timers: [...prevState.timers, [
                    setTimeout(this.redirect, 350)
                ]]
            }));
        } else if(res.validated === false) {
            this.setState(prevState => ({
                ...prevState,
                error: true,
                errorMessages: [
                    ...prevState.errorMessages.filter(err => err !== loginFailed && err !== loginError),
                    loginFailed
                ]
            }))
        }
    }

    onSubmit = (e) => {
        e.preventDefault()
        if(this.state.institutionId.trim() && this.state.key.trim()) {
            this.setState(prevState => ({
                ...prevState,
                error: false,
                errorMessages: []
            }))
            this.login();
        } else {   
            if(!this.state.institutionId.trim()) {
                this.setState(prevState => ({
                    ...prevState,
                    error: true,
                    errorMessages: [
                        ...prevState.errorMessages.filter(err => err !== emptyId && err !== loginFailed && err !== loginError),
                        emptyId
                    ]
                }))
            }
            if(!this.state.key.trim()) {
                this.setState(prevState => ({
                    ...prevState,
                    error: true,
                    errorMessages: [
                        ...prevState.errorMessages.filter(err => err !== emptyToken && err !== loginFailed && err !== loginError),
                        emptyToken
                    ]
                }))
            }
        }
    }

    render() {
        if(this.state.redirect === true) {
            return <Redirect push from={this.props.id} to={this.state.next} />
        }

        return (
          <LanguageConsumer> 
            {({polyglot}) => (
                <div className={`Login ${this.state.transition ? 'transition' : ''}`}> 
                <div className='login-container'> 
                    <div className='login-header'>
                        <h2>{polyglot.t('login')}</h2>
                    </div>
                    <form onSubmit={this.onSubmit}>
                        <div className='text-input-group'> 
                            <div className={`text-input  ${this.state.idFocus === true ? 'activeInput' : ''}`}>
                                <span className='input-icon'>
                                    <span className='fa fa-university'></span>
                                </span>
                                <input type='text' placeholder={polyglot.t('institution')} onChange={this.handleIdChange} onFocus={this.onIdFocus} onBlur={this.onIdBlur}></input>
                            </div>
                            <div className={`text-input ${this.state.keyFocus === true ? 'activeInput' : ''}`}>
                                <span className='input-icon'>
                                    <span className='fa fa-unlock-alt'></span>
                                </span>
                                <input type='password' placeholder={polyglot.t('key')} onChange={this.handleKeyChange} onFocus={this.onKeyFocus} onBlur={this.onKeyBlur}></input>
                            </div>
                            <div className='error-message' style={this.state.error === false ? {display: 'none'} : {display:'block'}}>
                                <ul>
                                    {
                                        this.state.errorMessages.map((err, i) => <li key={i}>{polyglot.t(err)}</li>)
                                    }
                                </ul>
                            </div>
                            <button> 
                                {polyglot.t('login')}
                            </button>
                            <a id='loginInfo' href='help#authorization'>{polyglot.t('accessInfo')}</a>
                        </div>
                    </form>
                </div>
                <Footer/>
            </div>)}
          </LanguageConsumer>
        )
    }
}
Login.contextType = LanguageContext;

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js